import { useMutation, useQueryClient } from '@tanstack/react-query';
import { jobPositionService } from '../services/jobPosition.service';
import type { CreateJobPositionRequest, JobPosition } from '../types/jobPosition.types';

interface UseCreateJobPositionReturn {
  createJobPosition: (
    data: CreateJobPositionRequest,
    options?: { onSuccess?: (data: JobPosition) => void; onError?: () => void }
  ) => void;
  createJobPositionAsync: (data: CreateJobPositionRequest) => Promise<JobPosition>;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
}

export function useCreateJobPosition(): UseCreateJobPositionReturn {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data: CreateJobPositionRequest) => jobPositionService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['job-positions'] });
    },
  });

  return {
    createJobPosition: mutation.mutate,
    createJobPositionAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
}
